<template>


    <div v-if="!loading">
        <el-card class="box-card booking-details-box"  :key="ticket.id" >
            <template #header>
                <el-row >
                    <el-col :span="6">
                        <el-tag class="mr-2 bdark" size="large" >TKT{{ticket.id}}</el-tag>
                        <el-tag class="mr-2" style="" size="large">
                            {{ticket.created_at}}</el-tag>
                        <el-tag class="mr-2" size="large">
                            {{ticket.created_for_department}}</el-tag>
                        <el-tag class="mr-2" style="" v-if="ticket.createdfor!=null" size="large">
                            <el-avatar class="mr-2" :size="20" :src="'https://crm.pickotrip.com/images/agents/'+ticket.createdfor+'.jpg'" />
                            {{ticket.createdfor}}</el-tag>

                    </el-col>
                    <el-col :span="18" >
                        <el-row justify="end">
                            <el-tag class="mr-2" effect="dark" type="primary" size="large" >{{ticket.created_by_department}}</el-tag>
                            <el-tag class="mr-2" style="" size="large">
                                <el-avatar class="mr-2" :size="20" :src="'https://crm.pickotrip.com/images/agents/'+ticket.createdby+'.jpg'" />
                                {{ticket.createdby}}</el-tag>
                            <el-tag class="mr-2" effect="dark" type="primary" size="large" >{{ticket.priority}}</el-tag>
                            <el-tag class="mr-2" size="large" effect="dark" :type="ticket.status=='Open'? 'success' : ticket.status=='Pending'? 'warning' : 'danger'" >{{ticket.status}}</el-tag>

                        </el-row>
                    </el-col>

                </el-row>


            </template>
            <div class="card-header-actions">
                <div class="title">{{ticket.category}}</div>
                <div class="actions">
                    <replay-tickets :ticket="ticket" @saved="getdata()"></replay-tickets>
                </div>

            </div>
        </el-card>


        <el-card class="m-2 box-card ticket-log-box"  v-for="log in ticket.logs"  >
            <template #header>
                <el-row >
                    <el-col :span="6">
                        {{log.createdby}}

                    </el-col>
                    <el-col :span="18" >
                        <el-row justify="end">
                            {{log.created_at}}
                        </el-row>
                    </el-col>

                </el-row>


            </template>
            <div>
                <el-text class="mx-1"  ><span v-html="log.description"></span></el-text>

            </div>
            <div>
                <a v-for="attachment in log.attachments" :href="attachment.link" target="_blank"><el-tag class="mr-2" type="info" >{{attachment.filename}}</el-tag></a>
            </div>
        </el-card>

    </div>
    <div v-else>
        <el-card class="box-card mt-2 booking-list-box" v-for="i in 7" :key="i">
            <el-skeleton :rows="1" animated />
        </el-card>

    </div>

</template>
<style>

</style>
<script>
import  { ElInput,ElSpace,ElPagination,ElText,ElCollapseItem,ElCollapse,ElSelect, ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton  } from 'element-plus'
import 'element-plus/dist/index.css'
import moment from 'moment'
export default {
    name: "ViewTicket",
    components: { ElInput,ElSpace,ElPagination,ElText,ElCollapseItem,ElCollapse,ElSelect,ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton },
    props:['id'],
    data() {
        return {
            loading: true,
            tickets:null

        }
    },
    mounted() {
        this.getdata();
    },
    methods: {
        getdata() {
            this.loading=true;
            let currentObj = this;
            axios.get('/tickets/'+this.id).then(function (response) {
                currentObj.ticket=response.data.ticket;
                currentObj.loading=false;

            })
                .catch(function (error) {
                    currentObj.loading=false;
                });
        }


    }
}
</script>

<style scoped>

</style>
